// IndexedDBのwrapperライブラリ https://dexie.org/
import Dexie from 'dexie';

// スキーマのバージョン
const SCHEMA_VERSION = 1;

export class IndexedDbObjectModel {
  private constructor(public key: string, public data: any, public lastModified: string) {}
}

interface TbsDatabase extends Dexie {
  tbsChannelApp: Dexie.Table<IndexedDbObjectModel, string>;
}

const dexieDb = new Dexie('tbs-database') as TbsDatabase;
dexieDb.version(SCHEMA_VERSION).stores({
  tbsChannelApp: 'key, data, lastModified',
});

export default dexieDb;
